// Product Add-Ons Handler for BjornQorn
// Handles: Croc Charm and Glitter Sticker Sheet
(function() {
  'use strict';
  
  // Product handles for each add-on (these should match your Shopify product handles)
  const ADDON_PRODUCTS = {
    'bq-croc-charm': null,
    'bq-glitter-sticker-sheet': null
  };

  // Fetch all add-on product details when page loads
  function fetchAddonProducts() {
    const promises = Object.keys(ADDON_PRODUCTS).map(handle => {
      return fetch(`/products/${handle}.js`)
        .then(response => {
          if (!response.ok) {
            console.warn(`Add-on product not found: ${handle}`);
            return null;
          }
          return response.json();
        })
        .then(product => {
          if (product && product.variants && product.variants.length > 0) {
            ADDON_PRODUCTS[handle] = product.variants[0].id;
            console.log(`Loaded add-on: ${handle} (ID: ${product.variants[0].id})`);
          }
          return product;
        })
        .catch(error => {
          console.error(`Error fetching ${handle}:`, error);
          return null;
        });
    });

    return Promise.all(promises);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    console.log('Add-ons script initialized');
    
    // IMMEDIATE button state check on page load (fixes back button)
    const submitButton = document.querySelector('[data-submit-button]');
    const submitButtonText = submitButton ? submitButton.querySelector('[data-submit-button-text]') : null;
    
    // Check if product has any available variants
    const variantSelect = document.querySelector('select[name="id"]');
    let hasAvailableVariant = false;
    if (variantSelect) {
      for (let i = 0; i < variantSelect.options.length; i++) {
        if (!variantSelect.options[i].disabled) {
          hasAvailableVariant = true;
          break;
        }
      }
    }
    
    // Set button to correct state immediately
    if (submitButton && submitButtonText) {
      if (hasAvailableVariant) {
        // In stock - reset to normal state
        submitButton.disabled = false;
        submitButtonText.innerText = 'Add to Cart';
      }
      // For sold out, don't touch it - let Liquid template handle it
    }
    
    // Fetch all add-on products
    fetchAddonProducts().then(() => {
      console.log('All add-on products loaded:', ADDON_PRODUCTS);
    });

    // Find the product form
    const productForm = document.querySelector('[data-product-form]');
    
    if (!productForm) {
      console.log('Product form not found - this script only works on product pages');
      return;
    }

    // Skip build-a-box products (they have their own submission handler)
    const productHandle = productForm.getAttribute('data-product-handle');
    if (productHandle === 'build-a-box') {
      console.log('Skipping add-ons script for build-a-box product');
      return;
    }

    // Skip if no add-ons are present (product is sold out or doesn't have add-ons)
    const addonSection = document.querySelector('.product-addons');
    if (!addonSection) {
      console.log('No add-ons section found - letting form submit normally');
      return;
    }

    // Intercept form submission
    productForm.addEventListener('submit', function(event) {
      event.preventDefault();
      
      // Get the main product variant ID and quantity
      const variantSelect = productForm.querySelector('select[name="id"]') || 
                           productForm.querySelector('input[name="id"]');
      const quantityInput = productForm.querySelector('input[name="quantity"]');
      const mainQuantity = quantityInput ? parseInt(quantityInput.value) : 1;
      
      if (!variantSelect) {
        console.error('Could not find variant selector');
        alert('Error: Could not find product variant. Please refresh and try again.');
        return;
      }

      const mainVariantId = variantSelect.value;
      
      // Check if a selling plan (subscription) is selected
      const sellingPlanInput = productForm.querySelector('input[name="selling_plan"]');
      const sellingPlanId = sellingPlanInput ? sellingPlanInput.value : null;
      
      if (sellingPlanId) {
        console.log('Subscription selected with selling plan ID:', sellingPlanId);
      }
      
      // Create a unique bundle ID for this cart addition
      // This links the main product to its add-ons
      const bundleId = 'bundle-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
      
      // Start with the main product
      const mainItem = {
        id: mainVariantId,
        quantity: mainQuantity,
        properties: {
          '_bundle_id': bundleId
        }
      };
      
      // Add selling plan if subscription is selected
      if (sellingPlanId) {
        mainItem.selling_plan = sellingPlanId;
      }
      
      const items = [mainItem];

      // Check which add-on checkboxes are checked
      const checkedAddons = [];
      const addonCheckboxes = document.querySelectorAll('.addon-checkbox:checked');
      
      addonCheckboxes.forEach(checkbox => {
        const handle = checkbox.getAttribute('data-addon-handle');
        const variantId = ADDON_PRODUCTS[handle];
        
        if (variantId) {
          // IMPORTANT: Add-ons always have quantity = 1, regardless of main product quantity
          items.push({
            id: variantId,
            quantity: 1,  // Fixed at 1
            properties: {
              '_Add-On': 'Yes',
              '_bundle_id': bundleId  // Link to main product
            }
          });
          checkedAddons.push(handle);
          console.log(`Adding add-on: ${handle} (qty: 1, bundle: ${bundleId})`);
        } else {
          console.warn(`Add-on ${handle} variant ID not found`);
        }
      });

      console.log('Adding to cart:', {
        mainProduct: mainVariantId,
        mainQuantity: mainQuantity,
        sellingPlan: sellingPlanId,
        bundleId: bundleId,
        addons: checkedAddons,
        totalItems: items.length
      });

      // Disable submit button to prevent double-clicks
      const submitButton = productForm.querySelector('[data-submit-button]');
      const submitButtonText = submitButton ? submitButton.querySelector('[data-submit-button-text]') : null;
      let originalText = '';
      
      if (submitButton && submitButtonText) {
        submitButton.disabled = true;
        originalText = submitButtonText.innerText;
        submitButtonText.innerText = 'Adding...';
      }

      // Add all items to cart using Shopify's AJAX API
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items: items })
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to add to cart');
        }
        return response.json();
      })
      .then(data => {
        console.log('Successfully added to cart:', data);
        // Redirect to cart page
        window.location.href = '/cart';
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        alert('There was an error adding items to your cart. Please try again.');
        
        // Re-enable button on error
        if (submitButton && submitButtonText) {
          submitButton.disabled = false;
          submitButtonText.innerText = originalText;
        }
      });
    });
  }
})();